import { Component, OnInit, OnDestroy } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { UserService } from '@shared/services/user.service'
import { RouteNames } from '@shared/const/route/route-names.model'
import { AuthService } from '@shared/services/auth.service'
import { Subscription } from 'rxjs'
import { EmailService } from '@shared/services/email.service'
import { Email } from '@shared/const/email/email.const'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = []
  TABS = {
    LOGIN: 0,
    REGISTRATION: 1,
  }
  currentTabIndex = 0
  loginForm: FormGroup
  registerForm: FormGroup
  resetEmail = ''

  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private emailService: EmailService,
    private fb: FormBuilder
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    })

    this.registerForm = this.fb.group({
      displayName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    })
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.userLoggedinEvent.subscribe(isLoggedIn => {
        isLoggedIn
          ? this.router.navigate(['/' + RouteNames.PATH_EVENT])
          : this.router.navigate(['/' + RouteNames.PATH_LOGIN])
      })
    )
  }

  onLogin(event) {
    this.userService.save(event)
    if (this.currentTabIndex === this.TABS.REGISTRATION) {
      this.emailService.send(
        Email.ADMIN.EMAIL,
        Email.ADMIN.EMAIL,
        Email.MESSAGE.REGISTRATION.SUBJECT,
        this.getRegistrationEmailWithParams(event.email, event.displayName)
      )
    }
  }

  getRegistrationEmailWithParams(email: string, displayName: string): string {
    return Email.MESSAGE.REGISTRATION.HTML.replace('{email}', email).replace('{displayName}', displayName)
  }

  signInGoogle() {
    this.authService.signInWithGoogle()
  }

  onLoginSubmit() {
    if (this.loginForm.invalid) {
      return
    }
    const { email, password } = this.loginForm.value
    this.authService.signInWithEmailAndPassword(email, password).catch(error => console.error(error))
  }

  onRegisterSubmit() {
    if (this.registerForm.invalid) {
      return
    }
    const { displayName, email, password } = this.registerForm.value
    this.authService
      .createUserWithEmailAndPassword(displayName, email, password)
      .then(() => {
        this.emailService.send(
          Email.ADMIN.EMAIL,
          Email.ADMIN.EMAIL,
          Email.MESSAGE.REGISTRATION.SUBJECT,
          this.getRegistrationEmailWithParams(email, displayName)
        )
        this.currentTabIndex = this.TABS.LOGIN
      })
      .catch(error => console.error(error))
  }

  onForgotPassword() {
    if (!this.resetEmail) {
      return
    }
    this.authService.sendPasswordResetEmail(this.resetEmail, window.location.origin + '/login').catch(err => console.error(err))
  }

  tabChanged(index: number) {
    this.currentTabIndex = index
  }
}
